export default {
      id: "ic_arrow_up_dark-usage",
      viewBox: "0 0 15 10",
      url: "/" + "images/icons.3.109.2.svg#ic_arrow_up_dark-usage",
      toString: function () {
        return this.url;
      }
    }